export default __webpack_public_path__ + "static/media/web.a2986e13.svg";